import amplitude from 'amplitude-js';
import store from '../store';
import ConfigurationService from '../services/ConfigurationService';

class Amplitude {
  init() {
    const shop = store.getters['shopify/shop/get'];

    amplitude.getInstance().init(process.env.VUE_APP_AMPLITUDE);

    const identify = new amplitude.Identify().setOnce('website', shop);
    amplitude.identify(identify);
  }

  getInstance() {
    return amplitude.getInstance();
  }

  logEvent(message, payload) {
    payload = payload || {};

    payload.product_type = ConfigurationService.getCurrentType();
    payload.product_id = store.getters['shopify/product/get'].id;

    amplitude.getInstance().logEvent(message, payload);
  }
}

export default new Amplitude();
